import { render, staticRenderFns } from "./photo_toast.vue?vue&type=template&id=f5a7777a&scoped=true&"
import script from "./photo_toast.vue?vue&type=script&lang=js&"
export * from "./photo_toast.vue?vue&type=script&lang=js&"
import style0 from "./photo_toast.vue?vue&type=style&index=0&id=f5a7777a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../wx-ktv-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a7777a",
  null
  
)

export default component.exports